exports.defaultLanguage = 'de'
exports.allowedLanguages = ['de', 'en', 'fr', 'it']
